import React, { ReactNode } from 'react';

import { CmBox } from '..';

interface Props {
  children: ReactNode;
}
export const LoadingMask: React.FC<Props> = ({ children }) => {
  return (
    <CmBox
      position="fixed"
      /* NOTE chakraのモーダルが1400の設定であったため、それと比較して2000とした。 */
      zIndex="2000"
      backgroundColor="rgba(255,255,255, 0.3)"
      top="0"
      left="0"
      right="0"
      bottom="0"
    >
      {children}
    </CmBox>
  );
};
